import { formatKey } from '../Utils/Functions';
import * as actions from './Actions';

// Normalize rater type shape for the UI list
const parseRaterType = (payload) => ({
  id: payload.id,
  name: payload.name,
  title: formatKey(payload.name),
  description: payload.description || '',
  createdAt: payload.createdAt,
  updatedAt: payload.updatedAt,
});

// Reducer managing an array of rater types (like rolesReducer)
export const raterTypesReducer = (state = [], action) => {
  switch (action.type) {
    case actions.INITIALIZE_RATER_TYPES:
      // Expect an array of rater types in action.payload
      return (action.payload || []).map((rt) => parseRaterType(rt));

    case actions.ADD_RATER_TYPE:
      return [...state, parseRaterType(action.payload)];

    case actions.UPDATE_RATER_TYPE:
      return state.map((rt) =>
        rt.id === action.payload.id ? parseRaterType(action.payload) : rt
      );

    case actions.DELETE_RATER_TYPE:
      return state.filter((rt) => rt.id !== action.id && rt.id !== action.raterTypeId);

    case actions.CLEAR_RATER_TYPES_LIST:
      return [];

    default:
      return state;
  }
};

